import { render } from "./DiotWorkpaper.vue?vue&type=template&id=2bec5d82&scoped=true"
import script from "./DiotWorkpaper.vue?vue&type=script&lang=js"
export * from "./DiotWorkpaper.vue?vue&type=script&lang=js"

import "./DiotWorkpaper.vue?vue&type=style&index=0&id=2bec5d82&scoped=true&lang=css"
import "./DiotWorkpaper.vue?vue&type=style&index=1&id=2bec5d82&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bec5d82"]])

export default __exports__